import { isPromise } from './helpers/isPromise';
import { ValidateWithSync } from './types/ValidateWith';
import { FormError } from './types/Validator';

export const validateWithSync: ValidateWithSync = (...validators) => (
  ...params
) => {
  let lastError: FormError<{}> | undefined;
  validators.find(validator => {
    const validatorResult = validator(...params);

    lastError =
      isPromise(validatorResult) || validator === undefined
        ? undefined
        : validatorResult;

    return lastError !== undefined;
  });
  return lastError;
};
